export default __webpack_public_path__ + "static/media/plus-circle.9a4942b4.svg";